export default __webpack_public_path__ + "static/media/jenkins.d293485d.svg";